var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.overlay,"color":"white","opacity":"0.7","z-index":"9999"}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"50"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }